const Introduction1 = () => {
  return (
    <div className="relative h-[800px] flex items-center bg-black-900_01 md:h-auto" id="About">
      {/* 배경 비디오 */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline 
        className="absolute top-0 left-0 w-full h-full object-cover opacity-50"
      >
        <source 
          src="/videos/intro-1.mp4"
          type="video/mp4" 
        />
      </video>

      {/* 컨텐츠 영역 */}
      <div className="relative z-10 py-[264px] desktop:w-[84%] h-[800px] flex items-center justify-center px-14 md:h-auto md:w-full md:px-5">
        <div className="container-xs flex flex-col items-start gap-2">
          <h2 className="font-bold text-[52px] mobile:!text-[32px] !font-monasanscodensed heading ui text-shadow-ts3">HARVARD XR</h2>
          <h3 className="!font-mdedium text-[22px] mobile:!text-[16px] heading ui leading-[31px] desktop:w-[86%] !font-monasans md:w-full">
            Harvard XR is a student-led community where curious minds explore XR through projects, hackathons, and workshops. Our biggest event is the annual conference every April, where we connect, collaborate, and push boundaries with hands-on experiences and inspiring ideas.
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Introduction1;
